var map = {
	"./cubefield/GameSetup": [
		4721,
		721
	],
	"./hint/GameSetup": [
		7928,
		13,
		318,
		928
	],
	"./listmaster/GameSetup": [
		9176,
		13,
		176
	],
	"./mapselect/GameSetup": [
		6155,
		13,
		942,
		155
	],
	"./pindrop/GameSetup": [
		5046,
		13,
		942,
		46
	],
	"./quiz/GameSetup": [
		7675,
		13,
		318,
		675
	],
	"./snake/GameSetup": [
		2281,
		281
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1428;
module.exports = webpackAsyncContext;